function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles } from '@material-ui/core';
import uniqueId from 'lodash.uniqueid';
import Dialog from '../Dialog';
import FormBase from '../FormBase';
import PrimaryButton from '../PrimaryButton';
const useStyles = makeStyles(theme => ({
  // these form styles allow us to replicate the default flex behavior of a Dialog and its Content and Actions; our FormBase component wraps those, thereby breaking default behavior
  form: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }
}));

const DialogForm = ({
  cancelButtonText,
  children,
  DialogProps,
  loading,
  onClose,
  onSubmit,
  open,
  submitButtonContent,
  text,
  title,
  ...props
}) => {
  const classes = useStyles();
  const dialogId = uniqueId('dialogForm_');
  return React.createElement(Dialog, _extends({
    loading: loading,
    open: open,
    onClose: onClose,
    "aria-labelledby": dialogId,
    style: {
      minWidth: 300
    }
  }, DialogProps), React.createElement(FormBase, _extends({
    onSubmit: (values, actions) => onSubmit(values, actions).then(onClose),
    FormProps: {
      className: classes.form
    }
  }, props), formikProps => React.createElement(React.Fragment, null, title && React.createElement(DialogTitle, {
    id: dialogId
  }, title), React.createElement(DialogContent, null, text && React.createElement(DialogContentText, null, text), children(formikProps)), React.createElement(DialogActions, null, React.createElement(PrimaryButton, {
    type: "submit",
    disabled: formikProps.isSubmitting
  }, submitButtonContent), React.createElement(Button, {
    disabled: formikProps.isSubmitting,
    onClick: e => {
      e.stopPropagation();
      onClose(e);
    },
    color: "primary"
  }, cancelButtonText)))));
};

DialogForm.propTypes = {
  cancelButtonText: PropTypes.string,
  DialogProps: PropTypes.object,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  submitButtonContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  text: PropTypes.string,
  title: PropTypes.string
};
DialogForm.defaultProps = {
  cancelButtonText: 'Cancel',
  submitButtonContent: 'Submit'
};
export default DialogForm;